module.exports = __webpack_public_path__ + "media/newstyle/images/pocket-75c48386ccb118d796be5359aa85fe73.svg";